import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { SubscriptionPlans } from "@prisma/client";

import Button from "@musicfy/components/Button";
import Divider from "@musicfy/components/Divider";
import { useSubscriptionContext } from "@musicfy/libs/SubscriptionProvider";

import { SettingsPanel, type TSettingsPanel } from "../../types";
import SubscriptionDetails from "../BasicInfo/SubscriptionDetails";
import Payments from "../Payments";

interface BillingProps {
  setActivePanel: (panel: TSettingsPanel) => void;
  onClose: () => void;
}

const Billing = ({ setActivePanel, onClose }: BillingProps): JSX.Element => {
  const { subscription } = useSubscriptionContext();
  const isPaid = !!subscription && subscription.plan !== SubscriptionPlans.free;
  const hasPaddlePaymentHistory = isPaid && subscription?.provider === "paddle";

  return (
    <div className="mx-auto w-full max-w-screen-xl">
      <Button
        variant="text"
        style="tertiary"
        className="text-22"
        onClick={() => setActivePanel(SettingsPanel.general)}
        preIcon={<ArrowBackIcon />}
      >
        Account Settings
      </Button>

      <div className="mt-9 flex flex-col gap-3">
        <div className="flex flex-wrap items-center gap-3">
          <h1 className="text-32 font-medium">Billing &amp; Subscription</h1>
          {isPaid && subscription && (
            <span className="rounded-full border border-white/15 bg-white/5 px-3 py-1 text-12 font-bold uppercase tracking-wide text-white/70">
              {subscription.provider}
            </span>
          )}
        </div>
        <p className="text-16 text-gray-500">
          Manage your plan, billing schedule, payment method, and invoices.
        </p>
      </div>

      <div className="mt-9 rounded-12 border border-white/10 bg-white/[0.03] p-6 xl:p-9">
        <div className="flex flex-col gap-8">
          <SubscriptionDetails setActivePanel={setActivePanel} />
        </div>
      </div>

      {hasPaddlePaymentHistory && (
        <>
          <Divider className="my-10" />
          <Payments
            setActivePanel={setActivePanel}
            onClose={onClose}
            embedded
          />
        </>
      )}
    </div>
  );
};

export default Billing;
